export enum AdditionalCostsCategory {
  ADDITIONAL_COST_TYPE = 'Additional Cost Type',
}

export enum AdditionalCostsCategoryFields {
  CF_SUPERVISOR_COSTS = 'CF Supervisor Costs',
  MISCELLENOUS = 'Miscellenous',
}
